import { render } from "./WelcomePrivacyPolicy.vue?vue&type=template&id=cc4b8ab2&scoped=true"
import script from "./WelcomePrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./WelcomePrivacyPolicy.vue?vue&type=script&lang=js"

import "./WelcomePrivacyPolicy.vue?vue&type=style&index=0&id=cc4b8ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc4b8ab2"]])

export default __exports__